import React from 'react';
import '../styles/NotificationPermissionModal.css';

const NotificationPermissionModal = ({ isOpen, onClose, onAllow, permissionStatus }) => {
    if (!isOpen) return null;

    return (
        <div className="notification-modal-overlay">
            <div className="notification-modal-content">

                {permissionStatus === 'denied' ? (
                    <>
                        <span className="modal-icon" role="img" aria-label="blocked">🔕</span>
                        <h2>Bildirimler Engellendi</h2>
                        <p>
                            Yeni iş fırsatlarını kaçırmamak için bildirimlerinizi açmanızı öneririz.
                            Tarayıcı ayarlarından engeli kaldırabilirsiniz.
                        </p>

                        <div className="denied-help">
                            <h3><span className="material-symbols-outlined" style={{ fontSize: '18px' }}>info</span> Nasıl Açılır?</h3>
                            <ol>
                                <li>Tarayıcının adres çubuğundaki 🔒 <strong>Kilit</strong> veya ⚙️ <strong>Ayarlar</strong> simgesine tıklayın.</li>
                                <li><strong>"İzinler"</strong> veya <strong>"Bildirimler"</strong> kısmını bulun.</li>
                                <li>Anahtarı açın veya <strong>"İzin Ver"</strong> seçeneğini işaretleyin.</li>
                                <li>Sayfayı yenileyin.</li>
                            </ol>
                        </div>

                        <div className="modal-actions" style={{ marginTop: '20px' }}>
                            <button className="btn-later" onClick={onClose}>Anladım, Kapat</button>
                        </div>
                    </>
                ) : (
                    <>
                        <span className="modal-icon" role="img" aria-label="bell">🔔</span>
                        <h2>Fırsatları Kaçırma!</h2>
                        <p>
                            Yeni bir iş ilanı yayınlandığında veya teklifine yanıt geldiğinde anında haberdar olmak ister misin?
                        </p>
                        <div className="modal-actions">
                            <button className="btn-allow" onClick={onAllow}>
                                <span className="material-symbols-outlined">notifications_active</span>
                                Bildirimleri Aç
                            </button>
                            <button className="btn-later" onClick={onClose}>Daha Sonra</button>
                        </div>
                    </>
                )}

            </div>
        </div>
    );
};

export default NotificationPermissionModal;
